import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { createHashRouter, RouterProvider } from 'react-router-dom';

import { ApiContextProvider } from 'api/ApiContext';
import { BreadcrumbsContextProvider } from 'lib/WAPBreadcrumbs/BreadcrumbsContext';
import ErrorMessage from 'lib/ErrorMessage/ErrorMessage';
import { REFETCH_INTERVAL } from 'api/getFetchData';
import usePersistHashOnPrint from 'utils/usePersistHashOnPrint';
import Overview from './overview/Overview';
import PollDay from './pollDay/PollDay';
import Poll from './poll/Poll';
import Archive from './archive/Archive';
import CurrentPoll from './currentPoll/CurrentPoll';
import Issues from './archive/Issues';
import Dates from './archive/Dates';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      cacheTime: 0,
      refetchInterval: REFETCH_INTERVAL,
      staleTime: REFETCH_INTERVAL,
    },
  },
});

const router = createHashRouter([
  {
    path: '/',
    element: <Overview />,
    errorElement: <ErrorMessage />,
    children: [
      {
        path: '/',
        element: <CurrentPoll />,
        errorElement: <ErrorMessage />,
      },
      {
        path: 'archiv',
        element: <Archive />,
        errorElement: <ErrorMessage />,
        children: [
          {
            path: '',
            errorElement: <ErrorMessage />,
            element: <Dates />,
          },
          {
            path: 'vorlagen',
            element: <Issues />,
            errorElement: <ErrorMessage />,
          },
        ],
      },
    ],
  },
  {
    path: '/:id/:dateUnused?',
    errorElement: <ErrorMessage />,
    element: <PollDay />,
  },
  {
    path: '/:parentDate/:id/:title/*',
    errorElement: <ErrorMessage />,
    element: <Poll />,
  },
]);

interface Props {
  apiUrl: string;
  archiveApiUrl: string;
  mapUrl: string;
  previewUser?: string;
  previewPassword?: string;
  navigationCurrent: string;
  navigationSource: string;
}

const WAPWrapper = ({
  apiUrl,
  archiveApiUrl,
  mapUrl,
  previewUser,
  previewPassword,
  navigationCurrent,
  navigationSource,
}: Props) => {
  usePersistHashOnPrint();

  return (
    <QueryClientProvider client={queryClient}>
      <ApiContextProvider
        apiUrl={apiUrl}
        archiveApiUrl={archiveApiUrl}
        mapUrl={mapUrl}
        previewUser={previewUser}
        previewPassword={previewPassword}
      >
        <BreadcrumbsContextProvider
          navigationCurrent={navigationCurrent}
          navigationSource={navigationSource}
        >
          <RouterProvider router={router} />
        </BreadcrumbsContextProvider>
      </ApiContextProvider>
    </QueryClientProvider>
  );
};

export default WAPWrapper;
